import React, { Component, useEffect } from "react";
import { inject, observer } from "mobx-react";
import AgGrid from '../../../common/components/ag-grid/ag-grid'
import { Formik, Form } from "formik";
import * as Yup from "yup";
import RestEndPoint from '../../../common/RestEndPoint';
import { FacilityFormFields, ButtonsComponent } from './user-facility-mapping-form-controls'
import { formFields } from "../constants/outage-user-facility-mapping";
import CheckboxRenderer from "../../../common/CheckboxRenderer";
import { DateFormatter } from '../../../common/DateFormatterWithZone';
import { sortFacilityAssets } from "../constants/outage-user-facility-mapping";
import { BooleanTextFormatter } from "../../../common/BooleanFormatter";

@inject("OutageScheduleUserStore", "CommonStore")
@observer
class UserFacilityMapping extends Component {
    constructor(props) {
        super(props)
        this.state = {
            gridOptions: {
                suppressClickEdit: true,
                pagination: true,
                stopEditingWhenGridLosesFocus: true,
                autoSizeAllColumns: true,
                floatingFilter: true,
                enableRangeSelection: true,
                rowSelection: "single",
                rowGroupPanelShow: "always",
                suppressContextMenu: true,
                statusBar: {
                    statusPanels: [
                        {
                            statusPanel: "agTotalAndFilteredRowCountComponent",
                            align: "left",
                        },
                        {
                            statusPanel: "agAggregationComponent",
                            statusPanelParams: {
                                aggFuncs: ["avg", "count", "min", "max", "sum"],
                            },
                        },
                    ],
                },
                sideBar: {
                    toolPanels: [
                        {
                            id: "columns",
                            labelDefault: "Columns",
                            labelKey: "columns",
                            iconKey: "columns",
                            toolPanel: "agColumnsToolPanel",
                        },
                    ],
                    showToolPanel: false,
                },
                defaultColDef: {
                    enableRowGroup: true,
                    enablePivot: true,
                    enableValue: true,
                    sortable: true,
                    filter: true,
                    resizable: true,
                },
                frameworkComponents: {
                    booleanCellEditor: CheckboxRenderer,
                    dateFormatter: DateFormatter,
                    booleanTextFormatter: BooleanTextFormatter
                },
            },
            primaryContactSuggestions: [],
            userGroups: [],
            regionDefaultValue: 'All'
        }
    }
    componentDidMount() {
        const {
            OutageScheduleUserStore: { getCurrentScreen },
            CommonStore: { screenDetails },
            userMgmtpath
        } = this.props
        const { regionDefaultValue } = this.state
        const currentScreen = getCurrentScreen(userMgmtpath, screenDetails)
        const userGroups = currentScreen.screenColumns?.find((x) => x.name === "GroupId")
            .refLookupData?.lookupValues.values
        this.setState({ userGroups: userGroups })
        this.getData(regionDefaultValue)
    }
    getData = (selectedRegion) => {
        const {
            OutageScheduleUserStore,
            CommonStore,
            selectedRow,
            isAddMode,
            isViewMode
        } = this.props
        let userId = 0
        const currentScreen = this.getCurrentScreen()
        if (!isAddMode || isViewMode) {
            userId = selectedRow.ID
        }
        OutageScheduleUserStore.getGridColumns(currentScreen)
        OutageScheduleUserStore.getUfmRowData(sortFacilityAssets(currentScreen),
            userId, selectedRegion)
    }
    getCurrentScreen = () => {
        const { CommonStore } = this.props
        const currentScreen = CommonStore.screenDetails
            .find(item => item.screen.name === "OutageUserFacilityMapping")
        return currentScreen
    }
    onRegionChange = selectedOption => {
        const selectedRegion = selectedOption.label
        this.setState({regionDefaultValue: selectedRegion})
        this.getData(selectedRegion)
    }
    loadSuggestion = async (target, controlName) => {
        const val = target.currentTarget.value;
        if (val.length >= 3) {
            var users = await RestEndPoint.getUsers(val);
            if (users?.data?.value?.length && controlName == "Primary") {
                this.setState({ primaryContactSuggestions: users.data.value })
            }
        }
    }
    resetPrimaryContact = () => {
        this.setState({ primaryContactSuggestions: [] });
    }
    getValidationSchema = () => Yup.object().shape({
        GroupId: Yup.string().required("User Group is required"),
        UserName: Yup.string().required("User Name is required"),
        EmailId: Yup.string().required("User Email is required"),
        PhoneNumber: Yup.number().positive().nullable()
            .typeError('Please enter valid phone number with country code')
    })
    render() {
        const {
            OutageScheduleUserStore: {
                initialValues,
                ufmColDefs,
                ufmRowData,
                regions
            },
            selectedRow, isAddMode, formHandler, saveScreenData,
        } = this.props
        const { gridOptions, primaryContactSuggestions, userGroups, regionDefaultValue } = this.state
        return (
            <Formik
                initialValues={initialValues}
                validationSchema={this.getValidationSchema()}
                onSubmit={fields => saveScreenData(fields, gridOptions)}
            >
                {formik => {
                    useEffect(() => {
                        if (!isAddMode) {
                            formFields.forEach((key) => {
                                formik.setFieldValue(key, selectedRow[key], false)
                            })
                        }
                    }, []);
                    const props = {
                        ...formik,
                        userGroups,
                        isAddMode,
                        primaryContactSuggestions,
                        onRegionChange: this.onRegionChange,
                        regions,
                        closeForm: formHandler,
                        loadSuggestion: this.loadSuggestion,
                        resetPrimaryContact: this.resetPrimaryContact,
                        regionDefaultValue
                    }
                    return (
                        <Form>
                            <div className="col-md-12" style={{ margin: '15px' }}>
                                <FacilityFormFields {...props} />
                            </div>
                            <AgGrid
                                gridOptions={gridOptions}
                                columnDefs={ufmColDefs}
                                rowData={ufmRowData}
                            />
                            <ButtonsComponent {...props} />
                        </Form>
                    )

                }}
            </Formik>
        )
    }
}

export default UserFacilityMapping